<template>
  <div id="app">
    <router-view id="router" :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  mounted: function() {
    try {
      this.$router.replace(this.$route.fullPath || "/");
    } catch (err) {
      // Ignore
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700;800;900&display=swap');
#app {
font-family: 'Nunito', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

</style>
<!-- <style lang="sass" scoped>

@import "./assets/default.sass"

#app
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  min-height: 100vh
  width: 100vw
  padding: 0
  margin: 0

  #router
    height: 100%
    width: 100%

</style> -->
